<template>
  <div class="tinymce-editor-wrapper" :class="{ 'mobile-editor': isMobile }">
    <Editor
      api-key="jy93yxi812jgw4yh6pnrlmvir2yzyscznto1jz46xxe80epi"
      :id="editorId"
      v-model="content"
      :init="editorInit"
      @onChange="handleChange"
      @onInit="handleInit"
    />
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'TinyMCEEditor',
  components: {
    Editor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    mobile: {
      type: Boolean,
      default: false
    },
    height: {
      type: [Number, String],
      default: 400
    }
  },
  data () {
    return {
      content: this.value,
      isMobile: this.mobile || this.checkMobile(),
      editor: null
    }
  },
  computed: {
    editorId () {
      return `tinymce-editor-${this._uid}`
    },
    editorInit () {
      return {
        // 高度设置 - 模拟手机屏幕高度
        height: this.height,
        skin: 'oxide',
        content_css: 'default',

        // 语言设置
        language: 'zh_CN',
        language_url: '/tinymce/langs/zh_CN.js',

        // 工具栏配置 - 适合移动端内容编辑
        toolbar: 'undo redo | formatselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | link image media | removeformat | preview',

        // 插件配置
        plugins: 'lists link image media table code preview fullscreen paste importcss searchreplace autolink directionality visualblocks visualchars fullscreen template charmap hr pagebreak nonbreaking anchor insertdatetime advlist wordcount imagetools textpattern help emoticons autosave',

        // 菜单栏配置
        menubar: true,

        // 状态栏配置
        statusbar: true,

        // 内容样式 - 模拟移动端样式
        content_style: this.getMobileContentStyle(),

        // 图片上传配置
        images_upload_handler: this.handleImageUpload,
        automatic_uploads: true,
        file_picker_types: 'image',

        // 粘贴配置
        paste_data_images: true,
        paste_as_text: false,

        // 响应式配置
        resize: 'both',
        branding: false,
        elementpath: true,

        // 自动保存
        autosave_interval: '30s',
        autosave_retention: '20m',

        // 移动端优化设置
        mobile: {
          theme: 'silver',
          toolbar_mode: 'sliding'
        },

        // 内容区域宽度限制 - 模拟手机屏幕宽度
        width: '100%',
        max_width: 500,

        // 默认字体和大小
        font_formats: '微软雅黑=Microsoft YaHei;宋体=SimSun;黑体=SimHei;仿宋=FangSong;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;',
        fontsize_formats: '12px 14px 16px 18px 20px 24px 28px 32px 36px'
      }
    }
  },
  watch: {
    value (newVal) {
      console.log('内容变化1:', newVal)
      if (newVal !== this.content) {
        this.content = newVal
      }
    },
    content (newVal) {
      this.$emit('input', newVal)
      this.$emit('on-change', newVal)
    }
  },
  methods: {
    // 检测移动端
    checkMobile () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768
    },

    // 获取移动端内容样式 - 模拟手机屏幕显示
    getMobileContentStyle () {
      return `
        body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
          font-size: 16px;
          line-height: 1.6;
          color: #333;
          padding: 16px;
          max-width: 375px;
          margin: 0 auto;
          background: #fff;
          min-height: 500px;
        }
        p {
          margin-bottom: 12px;
          word-wrap: break-word;
        }
        img {
          max-width: 100% !important;
          height: auto !important;
          display: block;
          margin: 12px auto;
          border-radius: 4px;
        }
        blockquote {
          border-left: 4px solid #1890ff;
          padding-left: 12px;
          margin: 16px 0;
          color: #666;
          background: #f9f9f9;
          padding: 12px;
          border-radius: 4px;
        }
        pre {
          background: #f5f5f5;
          padding: 12px;
          border-radius: 4px;
          overflow-x: auto;
          font-size: 14px;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin: 16px 0;
          font-size: 14px;
        }
        table th, table td {
          border: 1px solid #e8e8e8;
          padding: 8px;
          text-align: left;
        }
        table th {
          background: #fafafa;
          font-weight: 500;
        }
        h1 { font-size: 24px; margin: 20px 0 16px; }
        h2 { font-size: 20px; margin: 18px 0 14px; }
        h3 { font-size: 18px; margin: 16px 0 12px; }
        h4 { font-size: 16px; margin: 14px 0 10px; }
        ul, ol {
          padding-left: 24px;
          margin: 12px 0;
        }
        li {
          margin: 6px 0;
        }
        a {
          color: #1890ff;
          text-decoration: none;
        }
        a:hover {
          text-decoration: underline;
        }
        video {
          max-width: 100% !important;
          height: auto !important;
        }
      `
    },

    // 图片上传处理
    handleImageUpload (blobInfo, success, failure, progress) {
      const formData = new FormData()
      formData.append('imgdata', blobInfo.blob(), blobInfo.filename())

      // 生成授权头
      const now = new Date()
      const hours = now.getHours().toString().padStart(2, '0')
      const minutes = now.getMinutes().toString().padStart(2, '0')
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const day = now.getDate().toString().padStart(2, '0')
      const year = now.getFullYear()
      const rawString = `zgkd_upimage_${hours}${minutes}${month}${day}${year}`
      const base64String = btoa(rawString)

      fetch('https://zgkd.zzrcfzjt.com/api/v1/upload/upload', {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': base64String
        }
      })
      .then(response => response.json())
      .then(result => {
        if (result.code === 200) {
          success(window.location.origin + result.data.path)
        } else {
          failure(result.msg || '上传失败')
        }
      })
      .catch(error => {
        failure('上传失败: ' + error.message)
      })
    },

    // 编辑器初始化
    handleInit (evt) {
      this.editor = evt.target
      this.$emit('on-init', evt.target)
    },

    // 内容变化处理
    handleChange (content, editor) {
      // console.log('内容变化2:', content)
      // this.content = content
    },

    // 设置内容
    setContent (content) {
      if (this.editor) {
        this.editor.setContent(content || '')
      }
      this.content = content || ''
    },

    // 获取内容
    getContent () {
      return this.editor ? this.editor.getContent() : this.content
    },

    // 清空内容
    clear () {
      this.setContent('')
    },

    // 窗口大小变化处理
    handleResize () {
      const newIsMobile = this.checkMobile()
      if (newIsMobile !== this.isMobile) {
        this.isMobile = newIsMobile
      }
    }
  },

  mounted () {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy () {
    // 清理事件监听
    window.removeEventListener('resize', this.handleResize)

    // 销毁编辑器
    if (this.editor) {
      this.editor.destroy()
      this.editor = null
    }
  }
}
</script>

<style lang="less" scoped>
.tinymce-editor-wrapper {
  // 模拟手机屏幕容器
  max-width: 420px;
  margin: 0 auto;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background: #f5f5f5;
  padding: 10px;

  /deep/ .tox {
    border: none !important;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    .tox-toolbar-overlord {
      background: #fafafa;
      border-bottom: 1px solid #e8e8e8;
    }

    .tox-editor-header {
      border-bottom: 1px solid #e8e8e8;
    }

    .tox-edit-area {
      border: none;
      background: #fff;
    }

    .tox-edit-area__iframe {
      background: #fff;
    }

    .tox-statusbar {
      background: #fafafa;
      border-top: 1px solid #e8e8e8;
    }
  }

  // 手机框架样式
  &::before {
    content: '';
    display: block;
    height: 30px;
    background: linear-gradient(90deg, #333 0%, #555 100%);
    border-radius: 8px 8px 0 0;
    margin: -10px -10px 10px;
    position: relative;
    text-align: center;

    &::after {
      content: '移动端预览';
      position: absolute;
      color: #fff;
      font-size: 12px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

// 全局TinyMCE样式调整
:global(.tox-tinymce) {
  border-radius: 8px !important;
}

:global(.tox-toolbar-overlord) {
  background: #fafafa !important;
}

// 编辑器内容区域限制宽度
:global(.tox-edit-area__iframe) {
  max-width: 400px !important;
  margin: 0 auto !important;
}
</style>
